<template>
  <div>
    <b-row>
      <b-col sm="12">
        <p>
          Zoekt u samen met een partner een woning? Dan is het nodig dat u <u>allebei</u> ingeschreven staat als woningzoekende. U kunt daardoor reageren op woningen die passend zijn bij het gezamenlijke huishoudinkomen en het aantal personen van het huishouden.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <h3>
          Wilt u zich samen met iemand anders inschrijven?
        </h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-radio-group id="checkbox-hasPartner" v-model="check.hasPartner">
          <b-form-radio value="Yes">Ja</b-form-radio>
          <b-form-radio value="No">Nee</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
    </b-row>
    <div v-if="check.hasPartner === 'Yes'">
      <b-row>
        <b-col sm="12">
          <h3>
            Staat uw partner bij ons ingeschreven als woningzoekende?
          </h3>
          <p>
            <strong>Let op!</strong> Als uw partner nog geen woningzoekende inschrijving bij {{skin.region}} heeft, klik dan op "nee". Heeft uw partner al wel een woningzoekende account bij {{skin.region}}? Klik dan op "ja".
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-radio-group id="checkbox-partnerHasAccount" v-model="check.partnerHasAccount">
            <b-form-radio value="Yes">Ja</b-form-radio>
            <b-form-radio :disabled="partnerExistsInDB" value="No">Nee</b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
      <b-row v-if="check.partnerHasAccount === 'No' || (check.partnerHasAccount === 'Yes' && partnerExistsInDB)">
        <b-col>
          <br/>
          <b-button variant="secondary" size="sm" class="mr-2 text-center" @click.stop="skipPartnerAndContinue">
            Overslaan en later koppelen
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
      </b-row>

      <retrieve-partner @skip="skipPartnerAndContinue" @partnerConnected="fetchData"
                        v-if="check.partnerHasAccount === 'Yes' && !partnerExistsInDB"/>

      <div v-if="check.partnerHasAccount === 'No' || (check.partnerHasAccount === 'Yes' && partnerExistsInDB)">
        <b-row>
          <b-col sm="12">
            <h2>
              Wat zijn de gegevens van uw partner?
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-transgender-alt"></i>
            <label for="letterhead">Spreek partner aan als*</label>
          </b-col>
          <b-col sm="6">
            <b-form-select
                    :options="formData.letterhead"
                    v-model="$v.form.letterhead.$model"
                    required
                    :state="$v.form.letterhead.$dirty ? !$v.form.letterhead.$invalid : undefined"

            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-tag"></i>
            <label for="initials">Voorletters*</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    id="initials"
                    maxlength="8"
                    v-model="$v.form.initials.$model"
                    placeholder=""
                    @change="onChangeInitials"
                    :state="$v.form.initials.$dirty ? !$v.form.initials.$invalid : undefined"
            />
            <b-form-text v-if="this.form.initials.length > 6">Let op: Het gaat hier om uw <strong>voorletters</strong>, niet uw voornaam.</b-form-text>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-user-tag"></i>
            <label for="lastname">Achternaam*</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    id="lastname"
                    v-model="$v.form.lastname.$model"
                    size="sm"
                    placeholder=""
                    :state="$v.form.lastname.$dirty ? !$v.form.lastname.$invalid : undefined"
            />
          </b-col>
        </b-row>

        <b-row v-if="partnerExistsInDB">
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-tag"></i>
            <label>Geboortedatum</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    size="sm"
                    :disabled="true"
                    :value="dutchDate(form.dob)"
            />
          </b-col>
        </b-row>

        <b-row v-if="!partnerExistsInDB" :class="{'is-invalid': ($v.form.dob.$dirty ? $v.form.dob.$invalid : false)}">
          <b-col sm="5" class="form-label">
            <i class="fad fax star"></i>
            <label for="dob">Geboortedatum*</label>
          </b-col>
          <b-col sm="6">
            <b-row class="date-wrap">
              <b-form-select
                      class="col-3 day-input"
                      v-model="form.dob_day"
                      :options="formData.days"
                      @change="checkDate"
                      required
              />
              <b-form-select
                      class="col-5"
                      v-model="form.dob_month"
                      :options="formData.months"
                      @change="checkDate"
                      required
              />
              <b-form-select
                      class="col-4"
                      v-model="form.dob_year"
                      :options="formData.years"
                      @change="checkDate"
                      required
              />
              <div class="invalid-feedback" v-if="($v.form.dob.$dirty ? $v.form.dob.$invalid : false)">
                Dit moet een bestaande datum van tenminste 18 jaar geleden zijn
              </div>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <h2>
              Wat zijn de contactgegevens van uw partner?
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-envelope"></i>
            <label for="email">E-mailadres</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="email"
                    id="email"
                    v-model="$v.form.email.$model"
                    size="sm"
                    :disabled="partnerExistsInDB"
                    :state="$v.form.email.$dirty ? !$v.form.email.$invalid : undefined"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-envelope-open"></i>
            <label for="cc_email">Mail ook naar</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="email"
                    id="cc_email"
                    v-model="$v.form.cc_email.$model"
                    size="sm"
                    placeholder=""
                    :state="secondaryEmailState"

            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-phone"></i>
            <label for="clt_mob">Telefoonnummer*</label>
          </b-col>
          <b-col :sm="showSecondNumber ? 6 : 5" :cols="showSecondNumber ? 12 : 10">
            <b-form-input
                    type="text"
                    id="clt_mob"
                    v-model="$v.form.phone.mobile.$model"
                    size="sm"
                    placeholder=""
                    @change="onChangePhone"
                    :state="$v.form.phone.mobile.$dirty ? !$v.form.phone.mobile.$invalid : undefined"

            />
          </b-col>
          <b-col class="addExtraPhone" sm="1" cols="2" v-if="!showSecondNumber" @click="showSecondNumber = true">
            <i class="fad fax fa-plus-circle"></i>
          </b-col>
        </b-row>
        <b-row v-if="showSecondNumber">
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-phone-plus"></i>
            <label for="clt_tel">Telefoonnummer 2</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="text"
                    id="clt_tel"
                    v-model="$v.form.phone.landline.$model"
                    size="sm"
                    @change="onChangePhone"
                    placeholder=""
                    :state="secondaryPhoneState"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-home"></i>
            <label for="copyAddress">Woont nu op</label>
          </b-col>
          <b-col sm="6">
            <b-form-group size="sm">
              <b-form-radio v-model="sameAddress" size="sm" name="copyAddress" :value="true">{{
                  addressLine
                }}
              </b-form-radio>
              <b-form-radio v-model="sameAddress" size="sm" name="copyAddress" :value="false">Anders</b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-search-location"></i>
            <label for="zipcode">Postcode*</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="text"
                    id="zipcode"
                    v-model="$v.form.zipcode.$model"
                    maxlength="7"
                    size="sm"
                    placeholder=""
                    @input="zipcodeCheck"
                    :state="$v.form.zipcode.$dirty ? !$v.form.zipcode.$invalid : undefined"
                    :disabled="sameAddress"
                    required
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-search-location"></i>
            <label for="housenumber">Huisnummer*</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="text"
                    id="housenumber"
                    v-model="$v.form.housenumber.$model"
                    size="sm"
                    placeholder=""
                    :disabled="sameAddress"
                    @focus="setActiveInput('housenumber')"
                    @blur="setActiveInput(null)"
                    @input="zipcodeCheck"
                    :state="$v.form.housenumber.$dirty ? !$v.form.housenumber.$invalid : undefined"
            />
            <div class="card d-none d-lg-block info-card" v-if="activeInput === 'housenumber'">
              <div class="card-body">
                Dit is inclusief eventuele toevoegingen
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-road"></i>
            <label for="street">Straat</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="text"
                    id="street"
                    v-model="form.street"
                    size="sm"
                    placeholder="Wordt automatisch ingevuld"
                    :state="$v.form.city.$dirty ? !$v.form.city.$invalid : undefined"
                    disabled
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-city"></i>
            <label for="city">Woonplaats</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="text"
                    id="city"
                    v-model="form.city"
                    size="sm"
                    placeholder="Wordt automatisch ingevuld"
                    :state="$v.form.city.$dirty ? !$v.form.city.$invalid : undefined"
                    disabled
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <h2>
              Wat is het inkomen van uw partner?
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>
              Vul hier het persoonlijke inkomen van uw partner in. Dat staat vermeld als ‘Verzamelinkomen’ op de persoonlijke inkomensverklaring die uw partner gratis kan opvragen bij de Belastingdienst. U kunt het inkomen ook eenvoudig uitrekenen met de rekenhulp. Het inkomen van inwonende kinderen hoeft u niet mee te tellen.
            </p>
            <p>
              Wij zijn verplicht uw inkomen om te rekenen naar het huidige jaar. Dit doen wij door de Rijksoverheid vastgestelde percentage. De omrekenfactor voor 2023 is 1,1279 en voor 2024 is dit 1,0413.
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-wallet"></i>
            <label for="income">Inkomen partner per jaar*</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="text"
                    id="income"
                    v-model="$v.form.income.$model"
                    size="sm"
                    placeholder=""
                    @focus="setActiveInput('income')"
                    @blur="setActiveInput(null)"
                    @change="onChangeIncome"
                    :state="$v.form.income.$dirty ? !$v.form.income.$invalid : undefined"
                    required
            />
          </b-col>
          <b-col offset-sm="3" sm="9" offset-xl="6" xl="6">
            <div class="disconnectedButtons">
              <b-button variant="info" size="sm" class="pull-left" @click="setCalculatorState(true)">
                Rekenhulp
              </b-button>
              <b-button variant="info" size="sm" class="pull-left" @click="$bvModal.show('bdPopup')">
                Belastingdienst
              </b-button>
            </div>
            <div class="card d-none d-lg-block info-card" v-if="activeInput === 'income'">
              <div class="card-body">
                Vul het bedrag in zonder punt en zonder cijfers achter de komma.
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="d-block d-lg-none" v-if="activeInput === 'income'">
          <b-col sm="12">
            <p class="text-muted">
              <i>
                Vul het bedrag in zonder punt en zonder cijfers achter de komma.
              </i>
            </p>
          </b-col>
        </b-row>
        <br/>
        <b-row v-if="form.aow">
          <b-col>
            <p>
              Er is vanaf 2022 een uitzondering voor ouderen met vermogen. Een corporatie mag ook een woning toewijzen met een huur boven de huurtoeslaggrenzen als het vermogen van een oudere hoger is dan €141.896 (alleenstaanden, prijspeil 2025) of €179.429 (meerpersoonshuishoudens, prijspeil 2025).
            </p>
          </b-col>
        </b-row>
        <b-row v-if="form.aow">
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-wallet"></i>
            <label for="capital">Mijn eigen vermogen is</label>
          </b-col>
          <b-col sm="6">
            <b-form-select
                :options="formData.capital"
                :disabled="this.noInput"
                v-model="$v.form.capital.$model"
                required
                :state="$v.form.capital.$dirty ? !$v.user.capital.$invalid : undefined"
            />
          </b-col>
        </b-row>

        <keep-alive>
          <IncomeCalculator
                  :open="calculatorModal"
                  @calculatorClosed="setCalculatorState(false)"
                  @calculatorEmitVal="setValueFromCalculator"
          />
        </keep-alive>
      </div>
    </div>
    <error-box v-if="postErrors.errors.length > 0" :errors="postErrors.errors"/>
    <FormButtons @next="next" @previous="$emit('previous')"/>
    <vuelidateErrorDialog :validator="$v.form" :state="errDialogVisible" parent="partner" @onClose="errDialogVisible = false"/>

    <b-modal
            title-html="<i class='fal fa-exclamation-circle'></i>&nbsp;&nbsp;Ontkoppelen van uw partner"
            id="deletePartnerDialog"
            size="lg"
            ok-title="Ontkoppelen"
            ok-variant="success"
            @ok="deletePartner"
            cancel-title="Niet Ontkoppelen"
            cancel-variant="danger"
            @cancel="fetchData"
    >
      <b-row>
        <b-col>
          U staat op het punt om de koppeling met uw partner te verbreken. Dit heeft gevolgen voor uw gezinsgrootte en het gezamenlijk inkomen. En die zijn weer belangrijk bij de bepaling van op welke woningen u kunt reageren. Weet u zeker dat u wilt ontkoppelen? U zult dan in ieder geval ook de vragen bij 'Uw gezin' over meeverhuizende personen nogmaals moeten beantwoorden.
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import { geodataService } from '@/_services'
import { getDays, getMonths, getYears } from '../../_helpers'
import { formatInitials, formatPhone, formatIncome } from '@/_helpers/transformers'
import { dobAboveEighteen, dutchPhone, dutchZipcode } from '@/_helpers/validators'
import { required, email } from 'vuelidate/lib/validators'
import IncomeCalculator from './IncomeCalculator'
import FormButtons from '@/components/_registration/FormButtons'
import RetrievePartner from '@/components/_registration/RetrievePartner'
import ErrorBox from '@/components/_registration/ErrorBox'
import dateTransformers from '@/mixins/dateTransformers'
import vuelidateErrorDialog from "@/components/VuelidateErrorDialog";
export default {
  mounted () {
    this.fetchData()
    if(this.$store.state.registration.errors[this.$options.name] !== undefined) {
      this.highlightInvalid = true
    }
  },
  components: { IncomeCalculator, FormButtons, RetrievePartner, ErrorBox, vuelidateErrorDialog },
  mixins: [dateTransformers],
  data: () => {
    return {
      skin: {
        region: process.env.VUE_APP_REGION,
      },
      sameAddress: false,
      highlightInvalid: false,
      errDialogVisible: false,
      partnerExistsInDB: false,
      showSecondNumber: false,
      hadPartnerAtStart: false,
      check: {
        partnerHasAccount: '',
        hasPartner: '',
      },
      address: {
        zipcode: '',
        housenumber: '',
        city: '',
        street: '',
      },
      form: {
        cc_email: '',
        city: '',
        letterhead: '',
        dob: '',
        email: '',
        housenumber: '',
        income: '',
        initials: '',
        initials_formatted: '',
        lastname: '',
        phone: {
          mobile: '',
          landline: ''
        },
        street: '',
        zipcode: '',
        dob_day: '',
        dob_month: '',
        dob_year: '',
        aow: 0,
        capital: 0
      },

      activeInput: '',

      formData: {
        letterhead: [
          { text: 'Kies...', value: '' },
          { text: 'Meneer', value: 'M' },
          { text: 'Mevrouw', value: 'F' },
          { text: 'Anders', value: 'B' }
        ],
        capital: [
          { text: 'minder dan 141.896', value: 0 },
          { text: 'meer dan 141.896', value: 1 },
          { text: 'meer dan 179.429', value: 2 }
        ],
        days: getDays(),
        months: getMonths(),
        years: getYears(18, 100)
      },
      calculatorModal: false,
      postErrors: {
        errors: []
      },
    }
  },
  validations: {
    form: {
      letterhead: { required },
      email: { required, email },
      phone: {
        mobile: { required, dutchPhone },
        landline: { dutchPhone }
      },
      initials: { required },
      lastname: { required },
      cc_email: { email },
      zipcode: { required, dutchZipcode },
      housenumber: { required },
      city: { required },
      income: { required },
      dob: { required, dobAboveEighteen },
      capital: {}
    }
  },
  name: 'Partner',
  computed: {
    addressLine () {
      return `${this.address.street} ${this.address.housenumber} in ${this.address.city}`
    },
    validated () {
      return !this.$v.$invalid || (this.check.hasPartner === 'No')
    },
    secondaryEmailState () {
      if (this.form.cc_email === '')
        return null // prevent empty field from showing a checkmark

      return this.$v.form.cc_email.$dirty ? !this.$v.form.cc_email.$invalid : undefined
    },
    secondaryPhoneState () {
      if (this.form.phone.landline === '')
        return null // prevent empty field from showing a checkmark
      return this.$v.form.phone.landline.$dirty ? !this.$v.form.phone.landline.$invalid : undefined
    },
  },
  activated () {
    this.highlightInvalid = false
    this.$v.$reset()

    this.fetchAddress()
    this.fetchData()
  },
  watch: {
    validated (val) {
      this.$emit('validated', val)
    },
    sameAddress (val) {
      if (val) {
        this.copyAddress()
      } else {
        this.form.zipcode = ''
        this.form.housenumber = ''
        this.form.city = ''
        this.form.street = ''
      }
    },
  },
  methods: {
    next () {
      this.$v.$touch()
      if (this.validated) {
        this.submit()
      } else {
        this.highlightInvalid = true
        this.errDialogVisible = true
      }
    },

    skipPartnerAndContinue () {
      this.check.hasPartner = "No"
      this.check.partnerHasAccount = ''
      this.next()
    },

    copyAddress () {
      this.form.street = this.address.street
      this.form.zipcode = this.address.zipcode
      this.form.housenumber = this.address.housenumber
      this.form.city = this.address.city
    },

    fetchAddress () {
      let _this = this

      const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }

      this.$http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/address`, options)
              .then(response => response.json())
              .then(result => {
                _this.address.street = result.street
                _this.address.zipcode = result.zipcode
                _this.address.housenumber = result.housenumber
                _this.address.city = result.city
              })
              .catch(function (err) {
                console.log('Fetch Error :', err)
              })

    },

    setActiveInput (data) {
      if (data !== this.activeInput) {
        this.activeInput = data
      }
    },

    checkDate () {
      if (this.form.dob_day !== '' && this.form.dob_month !== '' && this.form.dob_year !== '') {
        this.form.dob = this.form.dob_year + '-' + this.form.dob_month + '-' + this.form.dob_day
        this.$v.form.dob.$touch()
      }
    },

    async zipcodeCheck () {
      let result = await geodataService.getAddress(this.form.zipcode, this.form.housenumber)
      this.form.street = result.street
      this.$v.form.city.$model = result.city
      this.form.zipcode = result.zipcode
    },

    setCalculatorState (tog) {
      this.calculatorModal = tog
    },

    setValueFromCalculator (income) {
      this.form.income = formatIncome(income)
    },

    fetchData () {
      this.$bvModal.hide('deletePartnerDialog')
      this.loading = true
      let _this = this

      const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }

      this.$http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/partner`, options)
              .then(response => response.json())
              .then(result => {

                this.hadPartnerAtStart = result.exists
                this.check.hasPartner = result.exists ? 'Yes' : 'No'

                this.form.cc_email = result.cc_email
                this.form.city = result.city
                this.form.dob = result.dob
                this.form.email = result.email
                this.form.housenumber = result.housenumber
                this.form.income = formatIncome(result.income)
                this.form.initials = formatInitials(result.initials)
                this.form.letterhead = result.letterhead
                this.form.lastname = result.lastname
                this.form.phone = result.phone
                this.form.street = result.street
                this.form.zipcode = result.zipcode

                this.form.phone.landline = formatPhone(result.phone.landline)
                this.form.phone.mobile = formatPhone(result.phone.mobile)

                if (result.phone.landline.length > 5) {
                  this.showSecondNumber = true
                }

                if (result.exists) {
                  this.check.partnerHasAccount = 'Yes'
                  this.partnerExistsInDB = true

                  let dob_array = result.dob.split('-')
                  this.form.dob_day = dob_array[2]
                  this.form.dob_month = dob_array[1]
                  this.form.dob_year = dob_array[0]
                  this.$v.$touch()
                } else {
                  this.partnerExistsInDB = false
                }

              })
              .catch(function (err) {
                console.log('Fetch Error :', err)
              }).finally(() => {
        this.loading = false
      })
    },

    formatInitials(str) {
      let result = ''
      if(str.length) {
        let splitArr = str.split('')
        splitArr.forEach((character, i) => {
          if((/[a-zA-Z]/).test(character)) {
            result += character.toUpperCase() + '.'
          }
        })
      }
      return result
    },

    onChangeInitials() {
      this.form.initials = formatInitials(this.form.initials)
    },

    onChangePhone() {
      this.form.phone.landline = formatPhone(this.form.phone.landline)
      this.form.phone.mobile = formatPhone(this.form.phone.mobile)
    },

    onChangeIncome() {
      this.form.income = formatIncome(this.form.income)
    },

    doesPartnerExists () {
      let exists = null
      const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }

      return this.$http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/partner`, options)
              .then(response => response.json())
              .then(result => {
                return result.exists
              })
    },

    deletePartner() {
      let _this = this
      const url = `${process.env.VUE_APP_API_URL}/user/steps/partner`

      const requestOptions = {
        method: 'DELETE',
        headers: {'Content-Type': 'application/json'}
      }
      this.$http.fetch(url, requestOptions)
              .then(function (response) {
                if (response.status === 200) {
                  _this.$emit('reinit')
                  _this.fetchData()
                }
              })
    },

    async submit (force) {
      let _this = this
      // User does not want to signup with partner
      if (this.check.hasPartner === 'No') {

        // Check if partner is in DB, if so remove it
        if (!await this.doesPartnerExists()) {
          _this.$emit('next')
          return
        } else {
          this.$bvModal.show('deletePartnerDialog')
          return
        }
      }

      // Partner already existed, send put request
      if (this.partnerExistsInDB) {

        const requestOptions = {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            letterhead: this.form.letterhead,
            phone: this.form.phone,
            initials: this.form.initials,
            capital: this.form.capital,
            aow: this.form.aow,
            lastname: this.form.lastname,
            cc_email: this.form.cc_email,
            zipcode: this.form.zipcode,
            housenumber: this.form.housenumber,
            street: this.form.street,
            city: this.form.city,
            income: this.form.income.replace(/[^0-9]/g, ''),
          })
        }

        //store income to localstorage 
        localStorage.setItem('partnerincome', this.form.income.replace(/[^0-9]/g, ''))

        const url = `${process.env.VUE_APP_API_URL}/user/steps/partner`

        this.$http.fetch(url, requestOptions)
                .then(function (response) {
                  if (response.status === 200) {
                    _this.$emit('next')
                  }
                })

      } else { // create new partner account

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            dob: this.form.dob,
            letterhead: this.form.letterhead,
            email: this.form.email,
            phone: this.form.phone,
            initials: this.form.initials,
            capital: this.form.capital,
            aow: this.form.aow,
            lastname: this.form.lastname,
            cc_email: this.form.cc_email,
            zipcode: this.form.zipcode,
            housenumber: this.form.housenumber,
            street: this.form.street,
            city: this.form.city,
            income: this.form.income.replace(/[^0-9]/g, ''),
          })
        }

        const url = `${process.env.VUE_APP_API_URL}/user/steps/partner/new`

        this.$http.fetch(url, requestOptions)
                .then(async function (response) {
                  if (response.status === 200) {
                    _this.$emit('next')
                    _this.postErrors.errors = []
                  } else {
                    if (response.status === 400) {
                      _this.postErrors = await response.json()
                    }
                  }
                })
      }

    },
  }
}
</script>

<style scoped>
#copyAddress {
  font-size: 14px;
  padding: 5px 0;
  display: inline-block;
}

#copyAddress .link-style {
  color: #198EFD;
  cursor: pointer;
}

#copyAddress .link-style:hover {
  text-decoration: underline;
}
</style>
